import {ModalBody, ModalHeader, ModalParagraph, ModalTitle} from '@/components/ui/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledMedicalReportTextAreaModalHeader = styled(ModalHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledMedicalReportTextAreaModalTitle = styled(ModalTitle)(
    ({theme: {typography}}) => css`
        ${typography.textXl};
    `
)

export const StyledMedicalReportTextAreaModalParagraph = styled(ModalParagraph)(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
    `
)

export const StyledMedicalReportTextAreaModalBody = styled(ModalBody)(
    ({theme: {spacing}}) => css`
        gap: ${spacing * 2}px;
    `
)
